import Vue from 'vue'
import store from '@store'
import router from '@router'
import ElFormDialog from '@components/ElFormDialog'

const ElFormDialogCom = Vue.extend(ElFormDialog)
const instance = new ElFormDialogCom({
  store: store,
  router: router
}).$mount()

setTimeout(() => {
  document.getElementById('app').appendChild(instance.$el)
}, 1000)

// https://cn.vuejs.org/v2/guide/plugins.html
// https://cn.vuejs.org/v2/api/#vm-mount

Vue.use({
  install: function(Vue/*, options*/) {
    Vue.prototype.$formDlg = function(options) {
      instance.init(options).show()
    },
    Vue.prototype.$formDlgClose = function() {
      instance.close()
    }
  }
})

export default instance
